<template>
  <div>
    <v-card class="rounded-lg" elevation="0" color="#41916b">
      <v-card-title class="text-center justify-center py-2">
        <h5 class="font-weight-bold" style="color: white">
          {{ donorLabel }} 
        </h5>
      </v-card-title>

      <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
        <v-tabs-slider color="black" />
 
        <v-tab
          v-for="(tabItem, index) in tabs"
          :key="tabItem.title"
          :disabled="isTabDisabled(index)"
        >
          {{ tabItem.title }}
        </v-tab>
 
        <v-tab-item v-if="isPCR">
          <AntecedentesPCR :patientData="resource" @changeTab="handleChangeTab" />
        </v-tab-item>
 
        <v-tab-item>
          <AvalicaoMacroscopica
            :avaliacaoMacroscopica="avalicaoMacroscopica"
            @changeTab="handleChangeTab"
            @disableCaptation="disableCaptation = $event"
          />
        </v-tab-item>
 
        <v-tab-item>
          <component
            :is="captacaoComponent"
            @changeTab="handleChangeTab"
            @captationId="captationId = $event"
            @typeCaptation="typeCaptation = $event"
            @disableCaptationTeam="disableCaptationTeam"
            @hasRightKidney="rightKidney = $event"
            @hasLeftKidney="leftKidney = $event"
          />
        </v-tab-item>
 
        <v-tab-item>
          <EquipeCaptacao
            :captationId="captationId"
            :typeCaptation="typeCaptation"
            @changeTab="handleChangeTab"
          />
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import AvalicaoMacroscopica from "./pcr/AvalicaoMacroscopica-comp.vue"; 
import OrgonsCaptation from "./OrgonsCaptation.vue";
import EquipeCaptacao from "./EquipeCaptacaoForm.vue";
import AntecedentesPCR from "./AntecedentesPCRForm.vue"; 
import {compareStr} from "@/utils/compareStrings";
import { mapGetters } from "vuex"; 
export default {
  data() {
    return { 
      tab: 0,
      captationId: null,
      maxTabAllowed: 0,
      typeCaptation: null,
      disableCaptation: true,
      disableCaptationTeam: true,
    };
  },
 
  created() { 
    if(!this.resource.id) {
      this.returnToGrid();
    }
   },
 
  components: {
    AvalicaoMacroscopica, 
    OrgonsCaptation,
    EquipeCaptacao,
    AntecedentesPCR, 
  },

  watch: {
    'resource': {
      immediate: true,
      deep: true,
        handler(item) { 
          this.checkTab(item) 
        }
    },   
  },

  computed: {
    ...mapGetters({
      resource: "getPatientData",
      clinicalHistories: "getClinicalHistories",
      avalicaoMacroscopica: "getMacroscopicData",
    }),
 
    donorLabel() {
      return 'Paciente' + ' ' + this.resource.kind_of_donor + ' ' + '-' + ' ' + this.resource.name
    },
    
    isEditing() {
      return [
        'doacao-efetivada', 
        'doacao-nao-efetivada'
      ].includes(this.resource.donor_status_slug);
    },
 
    tabs() {
      const isME = this.resource.kind_of_donor == "ME";
      const isPCR = this.resource.kind_of_donor == "PCR";

      let baseTabs = [];

      if (isPCR) {
        baseTabs.push("ANTECEDENTES");
      }

      baseTabs.push("AVALIAÇÃO MACROSCÓPICA"); 
      baseTabs.push(
        `CAPTAÇÃO ${isME ? "ME" : "PCR"}`
      ); 

      baseTabs.push("EQUIPE DE CAPTAÇÃO");
 
      return baseTabs.map(title => ({ title }));
      
    },

    captacaoComponent() {
      return "OrgonsCaptation" 
    }, 

    donorStatus() {
      return this.resource.donor_status_slug
    },

    isPCR() {
      return compareStr(this.resource.kind_of_donor, "pcr")
    },

    hasClinicalHistory() { 
      return this.clinicalHistories &&
            this.clinicalHistories.id
    },

    hasMacroscopicEvaluation() {
      return this.avalicaoMacroscopica &&
            this.avalicaoMacroscopica.length &&
            this.avalicaoMacroscopica[0].id
    }
  },

  methods: {
    checkTab() { 
      if (this.isEditing) {
        this.disableCaptation = true
        this.maxTabAllowed = this.tab
        return
      }

      let calculatedTab = 0  
      switch (this.donorStatus) {

        case 'doacao-aut':  
          calculatedTab = this.isPCR
            ? (this.hasClinicalHistory ? 1 : 0)
            : 0
          break

        case 'doacao-iniciada':  
          calculatedTab = this.isPCR
            ? (this.hasMacroscopicEvaluation ? 2 : 1)
            : (this.hasMacroscopicEvaluation ? 1 : 0)
          break

        case 'orgao-captado':  
          calculatedTab = this.isPCR ? 3 : 2
          break 

        default:
          calculatedTab = 0
      }

      this.tab = calculatedTab 
      this.maxTabAllowed = calculatedTab
    }, 

    isTabDisabled(index) { 
      const isTeamTab = compareStr(this.tabs[index]?.title, "equipedecaptacao");

      if(compareStr(this.donorStatus, "doacaonaoefetivada") && isTeamTab) {
        return true;
      }

      if(this.isEditing) return false;

      return index > this.maxTabAllowed;
    },


    handleChangeTab(nextTab) {
      const isME = this.resource.kind_of_donor == "ME"
 
      if(this.isEditing ) {
        this.tab = nextTab
        return
      }
 
      this.tab = nextTab
 
      if(nextTab > this.maxTabAllowed) {
        this.maxTabAllowed = nextTab
      } 
      if(isME) {
        return
      }
    },

    returnToGrid() {
      this.$router.push("/pacientes");
    },
  },
};
</script> >
